import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";
import {BeforePlayerCareerEndEvent} from "@/modules/team/events/BeforePlayerCareerEndEvent";
import {AfterPlayerCareerEndEvent} from "@/modules/team/events/AfterPlayerCareerEndEvent";
import {BeforePlayerCareerPlanedEndEvent} from "@/modules/team/events/BeforePlayerCareerPlanedEndEvent";
import {AfterPlayerCareerPlanedEndEvent} from "@/modules/team/events/AfterPlayerCareerPlanedEndEvent";
import {Season} from "@/modules/season/entity";
import PlayerPlanedCareerEndActionScreen from "@/modules/team/components/PlayerPlanedCareerEndActionScreen.vue";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";

@injectable()
export default class PlayerCareerEnder {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ActionScreener) private actionScreener: ActionScreener,
  ) {
  }

  async plan(player: Player) {
    await this.em.emitAsync(new BeforePlayerCareerPlanedEndEvent(player));

    player.endsCareer = true;
    await player.save();

    if (player.team && player.team.user) {
      await this.actionScreener.show({
        component: PlayerPlanedCareerEndActionScreen,
        props: {player},
      });
    }

    await this.em.emitAsync(new AfterPlayerCareerPlanedEndEvent(player));
  }

  async end(season: Season, player: Player) {
    await this.em.emitAsync(new BeforePlayerCareerEndEvent(player));

    player.endsCareer = false;
    player.careerEndedAt = season.currentDate.toDate();
    player.team = null;
    await player.save();

    await this.em.emitAsync(new AfterPlayerCareerEndEvent(player));
  }

  async endMany(season: Season, players: Player[]) {
    await players
      .forEachAsync(async (player: Player) => await this.end(season, player));
  }
}
